import * as XLSX from "xlsx";

const EMAIL_ALIASES = ["email", "e-mail", "email address", "mail"];
const FIRST_ALIASES = [
  "first_name",
  "firstname",
  "first name",
  "first",
  "given name",
  "forename",
];

function normalizeHeader(h) {
  return String(h || "")
    .trim()
    .toLowerCase();
}

function pickColumn(headers, aliases) {
  for (const alias of aliases) {
    const idx = headers.findIndex((h) => normalizeHeader(h) === alias);
    if (idx >= 0) return idx;
  }
  return -1;
}

/**
 * Parse CSV/XLS/XLSX File into [{ email, first_name }]
 */
export async function parseMembersSpreadsheet(file) {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(new Uint8Array(buffer), { type: "array" });
  const sheetName = workbook.SheetNames[0];
  if (!sheetName) {
    throw new Error("Spreadsheet has no sheets");
  }
  const sheet = workbook.Sheets[sheetName];
  const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" });
  if (!rows.length) {
    return [];
  }

  const headers = rows[0];
  const emailIdx = pickColumn(headers, EMAIL_ALIASES);
  const firstIdx = pickColumn(headers, FIRST_ALIASES);

  if (emailIdx < 0 || firstIdx < 0) {
    throw new Error(
      "Could not find email and first name columns. Use headers like Email and First Name (Range Mate export)."
    );
  }

  const members = [];
  for (let i = 1; i < rows.length; i++) {
    const row = rows[i];
    const email = String(row[emailIdx] || "").trim();
    const first_name = String(row[firstIdx] || "").trim();
    if (!email && !first_name) continue;
    members.push({ email, first_name });
  }
  return members;
}
